import React from 'react'
import TextFieldUniversal from '../../validate/form/text/TextFieldUniversal'
import { useState } from 'react'

const TextareaFieldMain = ({ required, setValidate, setValueForm, forciblyValue, label, placeholder, rows = 2, className }) => {

    const [value, setValue] = useState('')

  return (
    <div className={className}>
		<TextFieldUniversal
			value={value}
			setValue={e => {
				setValueForm(e)
				setValue(e)
			}}
			setValidate={setValidate}
			label={label ? label : 'Текст'} 
			placeholder={placeholder ? placeholder : 'Введіть текст'}
			validates={{
				isEmpty: true,
			}}
			forciblyValue={forciblyValue}
			required={required}
			multiline
			rows={rows}
		/>
	</div>
  )
}

export default TextareaFieldMain